<!-- CouponReservationHelpModal.vue -->
<script setup>
import { watch } from "vue";
import { useDraggableModal } from "@/composables/useDraggableModal";

const props = defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(["close"]);

// 🔹 NOVO: arrastar o modal pelo título (não há cabeçalho próprio aqui).
// Este componente não desmonta entre aberturas (só alterna `show`), então
// recentraliza ao reabrir para a posição não persistir.
const {
  panelRef,
  panelStyle,
  isDragging,
  isDraggable,
  onHandlePointerDown,
  resetPosition,
} = useDraggableModal();

watch(
  () => props.show,
  (val) => {
    if (val) resetPosition();
  }
);

function closeModal() {
  emit("close");
}
</script>

<template>
  <div
    v-if="show"
    class="fixed inset-0 z-[9998] flex items-center justify-center bg-black/20"
    @click.self="closeModal"
  >
    <div
      ref="panelRef"
      :style="panelStyle"
      class="bg-surface rounded-lg p-4 max-w-md w-full shadow-lg max-h-[80vh] overflow-y-auto"
    >
      <h2
        class="text-xl font-semibold mb-3"
        :class="{
 'cursor-move select-none touch-none': isDraggable,
          'cursor-grabbing': isDragging,
        }"
        @pointerdown="onHandlePointerDown"
      >
        Sobre a seção Cupom-Reserva
      </h2>

      <p class="text-sm leading-relaxed text-gray-800 mb-3">
        Nesta página, você acompanha as <strong>reservas de coupon</strong>
        criadas durante fluxos de checkout, assinatura ou pagamento. A reserva
        funciona como um controle temporário para impedir inconsistências
        enquanto o uso do coupon ainda está sendo processado.
      </p>

      <div
        class="mb-4 rounded-md border border-blue-200 
 bg-blue-50  px-3 py-2.5"
      >
        <p class="text-sm text-blue-900 leading-relaxed">
          <strong>Dica:</strong> reservas ajudam a evitar que o mesmo coupon
          seja consumido de forma indevida durante etapas intermediárias do
          pagamento. Em regra, elas são criadas automaticamente pelo sistema.
        </p>
      </div>

      <ul
        class="list-disc pl-5 text-sm text-gray-700 space-y-1.5 mb-3"
      >
        <li>
          A coluna <strong>Cupom</strong> identifica o coupon reservado.
        </li>

        <li>
          A coluna <strong>Usuário</strong> mostra para quem aquela reserva foi
          criada.
        </li>

        <li>
          A coluna <strong>Assin.</strong> indica a assinatura vinculada,
          quando existir.
        </li>

        <li>
          O status <strong>Ativa</strong> indica que a reserva ainda pode ser
          consumida dentro do prazo.
        </li>

        <li>
          O status <strong>Consumida</strong> indica que a reserva foi usada
          com sucesso em uma operação.
        </li>

        <li>
          O status <strong>Cancelada</strong> indica que a reserva foi anulada
          antes de ser consumida.
        </li>

        <li>
          O status <strong>Expirada</strong> indica que o prazo de uso passou
          sem que a reserva fosse consumida.
        </li>

        <li>
          A coluna <strong>Criada</strong> mostra quando a reserva foi aberta.
        </li>

        <li>
          A coluna <strong>Expira</strong> mostra o limite temporal da reserva.
        </li>

        <li>
          As colunas <strong>Consumida</strong> e <strong>Cancelada</strong>
          indicam os respectivos momentos finais do ciclo da reserva.
        </li>

        <li>
          Clique sobre uma linha da tabela para abrir o
          <strong>card de detalhes</strong> da reserva.
        </li>

        <li>
          Use o menu da coluna <strong>Ações</strong> para visualizar, editar
          ou apagar a reserva, conforme as permissões disponíveis.
        </li>
      </ul>

      <div
        class="mb-4 rounded-md border border-yellow-200 
 bg-yellow-50  px-3 py-2.5"
      >
        <p class="text-sm text-yellow-900 leading-relaxed">
          <strong>Atenção:</strong> em fluxo normal, reservas devem ser criadas
          e consumidas automaticamente pelo backend. A criação ou edição manual
          deve ficar restrita a ajustes administrativos.
        </p>
      </div>

      <div class="mt-2 text-right">
        <button
          @click="closeModal"
          class="px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>

